import React, { createContext, useState, useContext, useEffect } from 'react';
import { setSpinnerCallbacks } from '../services/api/spinner-service';

interface SpinnerContextType {
  isLoading: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
}

const SpinnerContext = createContext<SpinnerContextType | undefined>(undefined);

interface SpinnerProviderProps {
  children: React.ReactNode;
}

export const SpinnerProvider: React.FC<SpinnerProviderProps> = ({
  children
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showSpinner = () => setIsLoading(true);
  const hideSpinner = () => setIsLoading(false);

  useEffect(() => {
    setSpinnerCallbacks(showSpinner, hideSpinner);
  }, []);

  return (
    <SpinnerContext.Provider value={{ isLoading, showSpinner, hideSpinner }}>
      {children}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => {
  const context = useContext(SpinnerContext);
  if (context === undefined) {
    throw new Error('useSpinner must be used within a SpinnerProvider');
  }
  return context;
};
